import type { FC } from 'react';
import {
  DevHubDialog,
  DevHubDialogTitle,
  DevHubDialogContent,
  DevHubDialogActions,
  DevHubButton,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';

export interface CancelConfirmDialogProps {
  open: boolean;
  onStay: () => void;
  onConfirmExit: () => void;
}

/**
 * CancelConfirmDialog component for managing the cancel confirmation dialog
 * @param param0 - Props for the component
 * @returns CancelConfirmDialog JSX element
 */
export const CancelConfirmDialog: FC<CancelConfirmDialogProps> = ({
  open,
  onStay,
  onConfirmExit,
}) => {
  return (
    <DevHubDialog open={open} onClose={onStay} maxWidth="sm" fullWidth>
      <DevHubDialogTitle>Confirm Exit</DevHubDialogTitle>

      <DevHubDialogContent>
        <DevHubTypography variant="body1" style={{ marginBottom: '1rem' }}>
          You have pending changes that will be lost if you exit.
        </DevHubTypography>

        <DevHubTypography variant="body2" style={{ color: '#f57c00' }}>
          <strong>Warning:</strong> All unsaved changes will be discarded. Are
          you sure you want to continue?
        </DevHubTypography>
      </DevHubDialogContent>

      <DevHubDialogActions>
        <DevHubButton onClick={onStay} variant="outlined">
          Stay on Page
        </DevHubButton>
        <DevHubButton
          onClick={onConfirmExit}
          variant="contained"
          color="primary"
        >
          Discard Changes & Exit
        </DevHubButton>
      </DevHubDialogActions>
    </DevHubDialog>
  );
};
